export default "__VITE_ASSET__DvM24UfK__"